import React from "react";
// components
import MNPGV2 from "./MNPGV2";
// types
import { TMainPageLayoutV2 } from "../type";
import FrameShape02 from "@/components/shapes/FrameShape02";
import FrameShape03 from "@/components/shapes/FrameShape03";


const MNPG005 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG005.rendered", props);

    if ( !props.template ) return null;

    return (
        <>
            <FrameShape02 />
            <FrameShape03 className="float-bob-y" />
            <div className="footer-widgets-wrapper">
                <div className="container">
                    <div className="row">
                        <MNPGV2 templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} />
                    </div>
                </div>
            </div>
        </>
    )
}

const Component = React.memo(MNPG005, (prevProps: TMainPageLayoutV2, nextProps: TMainPageLayoutV2) => {
    console.log("MNPG005.memo", { prevProps, nextProps });
    return true;
});

export default Component;
